import axios from './axios_interceptor';
import {get_jwt_token, loginRedirect} from './helper_funtions'

export const updateProductSettings = async (data) => {

    try {
        const token = get_jwt_token()
        loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        }; 
        let url = `/customer/urlsettings/`
        const response = await axios.put(url, data, config);
        return { data: response.data, error: null };

    } catch (e) {
        return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
    }
}

export const getProductSettings = async () => {

    try {
        const token = get_jwt_token()
        loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        };
        let url = `/customer/urlsettings/`
        const response = await axios.get(url, config);
        return { data: response.data, error: null };

    } catch (e) {
        return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
    }
}

export const getThickClientConfigurationsSettings = async () => {

    try {
        const token = get_jwt_token()
        loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        };
        let url = `/customer/thick-client-configurations/`
        const response = await axios.get(url, config);
        return { data: response.data, error: null };

    } catch (e) {
        return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
    }
}

export const registerAdmin = async () => {

    try {
        let url = `/register/`
        const response = await axios.get(url);
        return { data: response.data, error: null };

    } catch (e) {
        return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
    }
}

export const getEndUserProductSettings = async () => {

    try {
        const token = get_jwt_token()
        loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        };
        let url = `/customer/end-user-settings/`
        const response = await axios.get(url, config);
        return { data: response.data, error: null };

    } catch (e) {
        return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
    }
}

export const getCustomerInsightsSummary = async () => {
    try {
        const token = get_jwt_token();
        loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.get(`/super-admin/customer-insights-summary/`, config);
        return { data: response.data, error: null };
    } catch (e) {
        return { data: null, error: e.response?.data?.message || e.message };
    }
}


export const getCustomersList = async ({ page = 0, limit = 10, search = "", filterBy = "" }) => {
    try {
        const token = get_jwt_token();
        loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        const params = new URLSearchParams({ page, limit, search: search || "", filterBy: filterBy || "" });
        const url = `/customers/?${params.toString()}`;
        const response = await axios.get(url, config);
        return { data: response.data, error: null };
    } catch (e) {
        return { data: null, error: e.response?.data?.errors || e.message };
    }
}

export const getLicensePool = async (customer_id = null) => {
    try {
        const token = get_jwt_token();
        loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            params: customer_id != null ? { customer_id } : {},
        };
        const response = await axios.get("/super-admin/customer-license/", config);
        return { data: response.data, error: null };
    } catch (e) {
        return { data: null, error: e.response?.data?.errors || e.message };
    }
};

export const allocateCustomerLicense = async (payload) => {
    try {
        const token = get_jwt_token();
        loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.post("/super-admin/customer-license/", payload, config);
        return { data: response.data, error: null };
    } catch (e) {
        const detail = e.response?.data?.message || e.response?.data || e.message;
        return { data: null, error: Array.isArray(detail) ? detail : (typeof detail === "string" ? detail : detail?.errors) };
    }
}

export const updateCustomer = async (customer_id, payload) => {
    try {
        const token = get_jwt_token();
        loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.patch(`/customers/${customer_id}/`, payload, config);
        return { data: response.data, error: null };
    } catch (e) {
        return { data: null, error: e.response?.data?.message || e.response?.data?.errors || e.message };
    }
}


export const registerCustomer = async (payload) => {
    try {
        const token = get_jwt_token();
        loginRedirect(token);
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const formData = new FormData();
        formData.append("company_name", payload.company_name || "");
        formData.append("username", payload.username);
        formData.append("email", payload.email);
        formData.append("domain", payload.domain);
        formData.append("password", payload.password);
        formData.append("confirmpassword", payload.confirmpassword);
        const response = await axios.post("/customers/", formData, config);
        return { data: response.data, error: null };
    } catch (e) {
        const detail = e.response?.data?.errors?.message?.[0] || e.response?.data || e.message;
        const msg = Array.isArray(detail) ? detail.join(", ") : (typeof detail === "string" ? detail : detail?.errors?.message?.[0]);
        return { data: null, error: msg || "Failed to add customer." };
    }
}
